import React, { useState } from "react";
import emailjs from "emailjs-com";

const ScheduleForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    topics: [],
    meetingTimes: ["", "", ""],
    timeZone: "",
    heardAbout: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData((prev) => {
        const updatedTopics = checked
          ? [...prev.topics, value]
          : prev.topics.filter((topic) => topic !== value);
        return { ...prev, topics: updatedTopics };
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleMeetingChange = (index, value) => {
    const updatedTimes = [...formData.meetingTimes];
    updatedTimes[index] = value;
    setFormData({ ...formData, meetingTimes: updatedTimes });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = "Please complete this required field.";
    if (!formData.lastName) newErrors.lastName = "Please complete this required field.";
    if (!formData.email) newErrors.email = "Please complete this required field.";
    if (!formData.meetingTimes[0]) newErrors.meeting1 = "Please complete this required field.";
    if (!formData.timeZone) newErrors.timeZone = "Please complete this required field.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // EmailJS setup
      const templateParams = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        topics: formData.topics.join(", "), // Convert topics array to a comma-separated string
        meetingTimes: formData.meetingTimes.join(", "), // Convert meeting times array to a string
        timeZone: formData.timeZone,
        heardAbout: formData.heardAbout,
        message: formData.message,
      };

      // Send email using EmailJS
      emailjs
        .send("service_vzgul5p", "template_jeph2fr", templateParams, "I1EY11UtD0UQtDY2-")
        .then(
          (response) => {
            console.log("SUCCESS:", response);
            alert("Form submitted successfully!");
          },
          (err) => {
            console.log("FAILED:", err);
            alert("Failed to send email. Please try again later.");
          }
        );
    }
  };

  return (
    <div>
      <div className="p-6 max-w-4xl mx-auto shadow-md rounded-md md:mt-40 text-[#C3CDD3]">
        <h1 className="text-2xl font-bold mb-4 text-[#C3CDD3] hidden md:block lg:block">Schedule a Free Consultation</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* First and Last Name */}
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <input
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto mt-3 text-[#C3CDD3]"
                placeholder="First Name"
              />
              {errors.firstName && (
                <p className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto">
                  {errors.firstName}
                </p>
              )}
            </div>
            <div>
              <input
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto mt-3 text-[#C3CDD3]"
                placeholder="Last Name"
              />
              {errors.lastName && (
                <p className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto">
                  {errors.lastName}
                </p>
              )}
            </div>
          </div>

          {/* Email and Phone */}
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <input
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto mt-3 text-[#C3CDD3]"
                placeholder="Email Address"
              />
              {errors.email && (
                <p className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto">
                  {errors.email}
                </p>
              )}
            </div>
            <div>
              <input
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto mt-3 text-[#C3CDD3]"
                placeholder="Phone"
              />
            </div>
          </div>

          {/* Topics */}
          <div>
            <label className="block text-[#C3CDD3]">Which topics would you like to discuss?*</label>
            <div className="space-y-2">
              <label className="flex items-center space-x-2">
                <input type="checkbox" value="Privacy Solutions" onChange={handleChange} />
                <span className="text-[#C3CDD3]">Privacy Solutions</span>
              </label>
              <label className="flex items-center space-x-2">
                <input type="checkbox" value="Cybersecurity Solutions" onChange={handleChange} />
                <span className="text-[#C3CDD3]">Cybersecurity Solutions</span>
              </label>
              <label className="flex items-center space-x-2">
                <input type="checkbox" value="Privacy E-Learning" onChange={handleChange} />
                <span className="text-[#C3CDD3]">Privacy E-Learning</span>
              </label>
            </div>
          </div>

          {/* Meeting Times */}
          <div>
            <h2 className="text-lg font-semibold text-[#C3CDD3]">Meeting Dates and Times</h2>
            {[0, 1, 2].map((i) => (
              <div key={i} className="mt-2">
                <label className="block text-[#C3CDD3]">Preferred meeting date and time (option {i + 1})*</label>
                <input
                  type="datetime-local"
                  value={formData.meetingTimes[i]}
                  onChange={(e) => handleMeetingChange(i, e.target.value)}
                  className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto mt-3 text-[#C3CDD3]"
                />
                {errors[`meeting${i + 1}`] && (
                  <p className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto">
                    {errors[`meeting${i + 1}`]}
                  </p>
                )}
              </div>
            ))}
          </div>

          {/* Time Zone */}
          <div>
            <label className="block text-[#C3CDD3]">What is your time zone?*</label>
            <select
              name="timeZone"
              value={formData.timeZone}
              onChange={handleChange}
              className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto mt-3 text-[#C3CDD3]"
            >
              <option value="">Please Select</option>
              <option value="GMT">GMT</option>
              <option value="EST">EST</option>
              <option value="PST">PST</option>
            </select>
            {errors.timeZone && (
              <p className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto">
                {errors.timeZone}
              </p>
            )}
          </div>

          {/* Heard About */}
          <div>
            <label className="block text-[#C3CDD3]">How did you hear about us?</label>
            <input
              name="heardAbout"
              value={formData.heardAbout}
              onChange={handleChange}
              className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto mt-3 text-[#C3CDD3]"
              placeholder="How did you hear about us?"
            />
          </div>
          {/* Message */}
          <div>
            <label className="block text-[#C3CDD3]">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="bg-[#0D0D0D] border border-[#136690] border-opacity-30 py-2 w-full px-4 mx-auto mt-3 text-[#C3CDD3]"
              placeholder="Leave your message here"
            />
          </div>

          <button type="submit" className="bg-[#136690] text-white py-2 px-6 rounded-md mt-4">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default ScheduleForm;